// Import all generated manga-style illustrations
const base = "/generated_images";
const panel1Left = `${base}/90s_grandmother_preparing_ragi_4fed5388.png`;
const panel1Right = `${base}/Gen_Z_opening_modern_fridge_2c93a03f.png`;
const panel2Left = `${base}/90s_traditional_family_breakfast_f9c52bc8.png`;
const panel2Right = `${base}/Gen_Z_quick_breakfast_alone_41667c5d.png`;
const panel3Left = `${base}/90s_traditional_cooking_tools_c8217b54.png`;
const panel3Right = `${base}/Gen_Z_modern_kitchen_appliances_d8ad9e0b.png`;
const panel4Left = `${base}/90s_children_cooking_with_grandmother_6d0f12b0.png`;
const panel4Right = `${base}/Gen_Z_ordering_food_delivery_9e0639de.png`;
const panel5Left = `${base}/90s_natural_outdoor_snacks_b250d448.png`;
const panel5Right = `${base}/Gen_Z_packaged_snacks_9e227609.png`;
const panel6Left = `${base}/90s_evening_cooking_together_892a2661.png`;
const panel6Right = `${base}/Gen_Z_eating_with_screens_e586b2c5.png`;
const panel7Left = `${base}/90s_storytelling_evening_7d96b44d.png`;
const panel7Right = `${base}/Gen_Z_late_night_gaming_d923b668.png`;
const panel8Left = `${base}/90s_peaceful_early_sleep_5913adeb.png`;
const panel8Right = `${base}/Gen_Z_late_night_phone_scrolling_113cfbfa.png`;
const panel9Left = `${base}/90s_walking_to_market_cde3da9d.png`;
const panel9Right = `${base}/Gen_Z_package_delivery_4786dedb.png`;
const panel10Left = `${base}/90s_teaching_traditional_recipe_b62c6b3c.png`;
const panel10Right = `${base}/Gen_Z_watching_cooking_video_13b6bc81.png`;
const panel11Left = `${base}/90s_community_feast_e6660af0.png`;
const panel11Right = `${base}/Gen_Z_eating_alone_with_phone_beed842b.png`;
const panel12Left = `${base}/90s_storing_traditional_food_34a893e4.png`;
const panel12Right = `${base}/Gen_Z_food_waste_bb72783c.png`;

// Image mapping by panel number and side
export const imageMap: Record<string, string> = {
  "1-left": panel1Left,
  "1-right": panel1Right,
  "2-left": panel2Left,
  "2-right": panel2Right,
  "3-left": panel3Left,
  "3-right": panel3Right,
  "4-left": panel4Left,
  "4-right": panel4Right,
  "5-left": panel5Left,
  "5-right": panel5Right,
  "6-left": panel6Left,
  "6-right": panel6Right,
  "7-left": panel7Left,
  "7-right": panel7Right,
  "8-left": panel8Left,
  "8-right": panel8Right,
  "9-left": panel9Left,
  "9-right": panel9Right,
  "10-left": panel10Left,
  "10-right": panel10Right,
  "11-left": panel11Left,
  "11-right": panel11Right,
  "12-left": panel12Left,
  "12-right": panel12Right,
};

// Helper function to get image by panel number and side
export function getPanelImage(panelNumber: number, side: "left" | "right"): string {
  const key = `${panelNumber}-${side}`;
  return imageMap[key] || "";
}
